require('property/share-mail');

var cookies = require('cookies/cookie');


function disableUnavailableQuantities(){
    currentNbResult = $('#property-list-nbresults-title').data('nbresults');
    var previous = 0;
    $.each($('#quantity option'),function(index,value){
        if(($(this).val() > currentNbResult) && previous > $(this).val()){
            $(this).prop('disabled',true);
        }
        previous = $(this).val();
    });
}

function checkIfMoreOptionsMustBeOpened(){
    var $advancedInputs = $(":input","#propertyFormAdvancedSearch");

    $.each($advancedInputs,function(key,value){
        if($(value).attr('name') && ($(value).val()) ){
            $("#propertySearchOpenSearchBtn").trigger('click');
            return false;//break the loop
        }
    });
}

$(document).ready(function(){

    $('.display-switch').on('click', function(e) {
        e.preventDefault();
        $('.display-switch').toggleClass('selected');
        $('.property-list').toggleClass('list-view');
        cookies.set('megagence-display',$(this).data('viewmode'),365);
        return false;
    });

    $('input, select','.list-tools').on('change',function(){
        $('#listFilters').submit();
    });

    $('.btn-filter').on('click',function(){
        var me = $(this);
        var newFilterValue = "";
        if(me.hasClass('btn-filter-date')){
            newFilterValue = "update";
        }else if(me.hasClass('btn-filter-price')){
            newFilterValue = "price";
        }else if(me.hasClass('btn-filter-area')){
            newFilterValue = "area";
        }else if(me.hasClass('btn-filter-localite')){
            newFilterValue = "localite";
        }else{
            console.error('btn-filter must be date area price or localite filter');
            return null;
        }
        if(me.hasClass('btn-filter-price')){
            if(me.hasClass('btn-filter-asc')){
            newFilterValue += "Desc";
            }else{
                newFilterValue += "Asc";
            }
        }else{
            if(me.hasClass('btn-filter-desc')){
            newFilterValue += "Asc";
            }else{
                newFilterValue += "Desc";
            }
        }
        setUrlParameter("sortOrder",newFilterValue);
    });

    $('.checkbox-filter').on('click',function(){
        var me = $(this);
        var value = "";
        if(me.is(':checked')){
            value = 1;
        }
        var parameterName = me.data('parameter-name');
        if(parameterName){
            setUrlParameters([
                {
                    name: parameterName,
                    value: value,
                },
                {
                    name: 'page',
                    value: 1
                }
            ])
        }
    });


    $('.btn-mode-liste').on('click',function(){
        var me = $(this);
        if(me.hasClass('disabled')){
            return null;
        }

        if(me.hasClass('btn-mode-liste-simple')){
            setUrlParameter("listMode","simple");
        }else if(me.hasClass('btn-mode-liste-map')){
            setUrlParameter("listMode","map");
        }
    });

    $('.select-filter-quantity').on('change',function(){
        var me = $(this);
        var currentQuantity = getURLParameter('quantity');
        var newValue = me.val();
        if(currentQuantity != newValue){
            setUrlParameters([
                {
                    name: 'quantity',
                    value: newValue,
                },
                {
                    name: 'page',
                    value: 1
                }
            ])
        }
    });

    disableUnavailableQuantities();

/* 12/2017 more option never open by default megagence Ticket #99 */
    //checkIfMoreOptionsMustBeOpened();
});


